module.exports = __webpack_public_path__ + "static/media/vendor-2.8c1604cb.jpg";